module.exports = __webpack_public_path__ + "static/media/innovation-orion.89596f89.jpg";